/* ==========================================================================
   t26-ft.js — interactions for the Features page.
   Loaded after t26-os.js. Owns two widgets only:
     1. Billing term switcher   [data-ft-terms]
     2. Specifications accordion [data-ft-specs]
   Both are progressive: with JavaScript off the markup renders the default
   term and every spec panel reads in document order.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__t26FtInit) return;
  window.__t26FtInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function safe(name, fn) {
    try { fn(); } catch (e) { if (window.console) console.warn('[t26-ft] ' + name + ' failed', e); }
  }

  ready(function () {

    /* --------------------------------------------- 1. BILLING TERM SWITCH */

    /* Each plan card carries all three prices as data attributes rather than
       three hidden DOM copies, so the term buttons only ever rewrite text and
       the card cannot fall out of step with its own heading. */
    safe('terms', function () {
      document.querySelectorAll('[data-ft-terms]').forEach(function (root) {
        var btns = [].slice.call(root.querySelectorAll('[data-ft-term]'));
        var prices = [].slice.call(root.querySelectorAll('[data-ft-price]'));
        var notes = [].slice.call(root.querySelectorAll('[data-ft-note]'));
        if (!btns.length || !prices.length) return;

        function select(i) {
          var key = btns[i].getAttribute('data-ft-term');
          var label = btns[i].getAttribute('data-ft-label') || '';
          btns.forEach(function (b, n) { b.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });

          prices.forEach(function (el) {
            var v = el.getAttribute('data-ft-' + key);
            if (v) el.firstChild.nodeValue = v;
          });
          notes.forEach(function (el) { el.textContent = label; });
        }

        btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });

        /* Default to whichever button the Liquid marked pressed, so the editor
           decides the opening term rather than this file. */
        var start = 0;
        btns.forEach(function (b, i) { if (b.getAttribute('aria-pressed') === 'true') start = i; });
        select(start);
      });
    });

    /* ------------------------------------------------ 2. SPECS ACCORDION */

    safe('specs', function () {
      document.querySelectorAll('[data-ft-specs]').forEach(function (root) {
        [].slice.call(root.querySelectorAll('.ft-spec__btn')).forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          b.addEventListener('click', function () {
            var open = b.getAttribute('aria-expanded') === 'true';
            b.setAttribute('aria-expanded', open ? 'false' : 'true');
          });
        });
      });
    });

  });
})();
